import { render } from "./App.vue?vue&type=template&id=579121ab"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=579121ab&lang=css"

import exportComponent from "/home/avatar_sandbox_chat/avatar.chat.web/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__